import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loader: false,
  userData: null,
  privacy: null,
  changeEmail: {
    email: null,
    verify_token: null,
  },
  schedule_step: {
    step1: true,
    step2: false,
    step3: false,
    step4: false,
  },
  paymentModal: false,
  paymentList: [],
  notifications: [],
  unreadNotifications: [],
  stripeKey: []
};

const techsbookSlice = createSlice({
  name: "techbsook",
  initialState,
  reducers: {
    setLoader(state, action) {
      state.loader = action.payload;
    },
    setStripeKey(state, action) {
      state.stripeKey = action.payload;
    },
    setUserData(state, action) {
      state.userData = action.payload;
    },
    setPrivacy(state, action) {
      state.privacy = action.payload;
    },
    setNotifications(state, action) {
      state.notifications = action.payload
    },
    setUnreadNotifications(state, action) {
      state.unreadNotifications = action.payload
    },
    setEmailChange(state, action) {
      state.changeEmail = action.payload;
    },
    setScheduleStep(state, action) {
      state.schedule_step = { ...state.schedule_step, ...action.payload };
    },
    setPaymentModal(state, action) {
      state.paymentModal = action.payload;
    },
    setPaymentList(state, action) {
      state.paymentList = action?.payload;
    },
  },
});

export const {
  setLoader,
  setUserData,
  setPrivacy,
  setEmailChange,
  setScheduleStep,
  setPaymentModal,
  setPaymentList,
  setNotifications,
  setUnreadNotifications,
  setStripeKey
} = techsbookSlice.actions;

export default techsbookSlice.reducer;
